// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3XeQe","col":"styles_col__228kz","fulfillmentStatus":"styles_fulfillmentStatus__1Zvd0","emailCol":"styles_emailCol__1rGZE"};